import React from 'react'
import PropTypes from 'prop-types'

import { formatBRL } from 'utils/formatNumber'
import { Text, Icon } from 'components'
import styles from './PaymentCondition.module.scss'

const InfoCard = ({ value, text }) => (
  <div className={styles.infoCard}>
    <Text fontSize="medium" bold>
      {value}
    </Text>
    <Text fontSize="xsmall">{text}</Text>
  </div>
)

InfoCard.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

const Symbol = ({ symbol }) => (
  <Text fontSize="medium" bold>
    {symbol}
  </Text>
)

Symbol.propTypes = {
  symbol: PropTypes.string,
}

Symbol.defaultProps = {
  symbol: undefined,
}

const PaymentCondition = ({ conditions }) => {
  return (
    <div>
      {conditions.map((condition, conditionIndex) => (
        <div key={conditionIndex}>
          <Text
            fontSize="medium"
            color="lightTextColor"
            className={styles.cardTitle}
          >
            {condition.title}
          </Text>
          <div className={styles.cards}>
            {condition.content.map((contentData, contentIndex) => (
              <div key={contentIndex} className={styles.containerCard}>
                <InfoCard
                  value={formatBRL(contentData.value)}
                  text={contentData.description}
                />
                <Symbol symbol={contentData.sign} />
              </div>
            ))}
            {condition.info ? (
              <div className={styles.info}>
                <div className={styles.infoIcon}>
                  <Icon type="info" size={24} />
                </div>
                <Text fontSize="medium" color="lightTextColor">
                  {condition.info}
                </Text>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

PaymentCondition.propTypes = {
  conditions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default React.memo(PaymentCondition)
